// THE FIGURE CACHE, AND WHEN ITS FIGURES ARE RE-CHECKED (ZEN-735).
//
// Every figure a screen shows is kept here for a minute and reused, so moving
// between pages does not ask the server again each time. What decides when a
// kept figure is asked again is this file and nothing else. Maryse's ruling,
// 8 October 2026 ("option 1"): a figure re-checks
//
//   * when a save succeeds anywhere in the app — lib/api.js announces it;
//   * when she comes back to the browser tab;
//   * when she opens a list or a history that explains a figure, so the figure
//     and its explanation are always the same moment (recheckEverythingOnScreen,
//     called by those screens).
//
// Before this, coming back to the tab re-checked nothing, and each screen kept
// its own list of what to refresh after its saves. A card on the dashboard read
// $50.77 for a day while the list under it said $71.93.
import { QueryClient } from "@tanstack/react-query";
import { onSaveSucceeded } from "@/lib/api";

/**
 * Mark every kept figure out of date. The ones on screen are asked again now;
 * the rest are asked again the next time a screen shows them.
 */
export function recheckEverythingOnScreen(queryClient) {
  return queryClient.invalidateQueries();
}

export function makeQueryClient() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60_000,
        // "always", not true: true re-checks only figures older than the
        // minute above, so coming back to the tab half a minute after a save
        // made on a phone still showed the old figure. The ruling is
        // "whenever she comes back". (Found by queryClient.test.jsx.)
        refetchOnWindowFocus: "always",
        networkMode: "always",
        retry: 2,
      },
      mutations: {
        networkMode: "always",
      },
    },
  });
  onSaveSucceeded(() => { recheckEverythingOnScreen(queryClient); });
  return queryClient;
}
